import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  GetTransactionID(payload) {
    return Api().get(
      `/${API_VERSION}/webapp/transaction/id/${payload.cinema_code}`
    );
  },
  AddSeats(payload) {
    return Api().post(`/${API_VERSION}/webapp/transaction/seats/add`, payload);
  },
  SetSeats(payload) {
    return Api().post(`/${API_VERSION}/webapp/transaction/seats/set`, payload);
  },
  SetPrice(payload) {
    return Api().post(
      `/${API_VERSION}/webapp/transaction/seats/set-price`,
      payload
    );
  },
  BookSeats(payload) {
    return Api().post(`/${API_VERSION}/webapp/transaction/seats/book`, payload);
  },
  BookStatus(payload) {
    return Api().post(
      `/${API_VERSION}/webapp/transaction/seats/status`,
      payload
    );
  },
  GetFinalTicket(payload) {
    return Api().post(
      `/${API_VERSION}/webapp/transaction/final-ticket`,
      payload
    );
  },
  AddFnd(payload) {
    return Api().post(`/${API_VERSION}/webapp/transaction/add-fnd`, payload);
  },
  VerifyBooking(payload) {
    return Api().post(
      `/${API_VERSION}/webapp/transaction/verify-booking`,
      payload
    );
  },
  GetPayLaterTransactionDetails(payload) {
    return Api().get(
      `/${API_VERSION}/webapp/transaction/pay-later-transaction-details/${payload.transaction_id}`
    );
  },
  CompletePayLaterTransaction(payload) {
    return Api().put(
      `/${API_VERSION}/webapp/transaction/mark-pay-later-as-paid`,
      payload
    );
  },
  GetTodaysMovieDetails(payload) {
    return Api().post(
      `/${API_VERSION}/webapp/transaction/todays-show-details`,
      payload
    );
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/TransactionService.js